import { isTypeEmbedZohoForm } from '@platform/contentful';
import { Entry } from 'contentful';

const ContentfulEmbedZohoForm = ({
  entry,
}: {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  entry: Entry<any, 'WITHOUT_UNRESOLVABLE_LINKS', 'en-US'> | undefined;
}) => {
  if (!entry || !isTypeEmbedZohoForm(entry) || !entry.fields.publicUrl) {
    return null;
  }

  return (
    <div>
      <iframe
        // Append the search query string, as some forms like the newsletter subscription at /newsletter-subscribe
        // expect values to pre-fill based on query params
        src={entry.fields.publicUrl + (document?.location.search ?? '')}
        width={entry.fields.width}
        height={entry.fields.height}
        /* TODO: There are a bunch of Zoom fields here */
      />
    </div>
  );
};

export default ContentfulEmbedZohoForm;
